var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('v-card',{staticClass:"no-search-result"},[_vm._v(" No items match your search! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }